export default "__VITE_ASSET__bf365cde__"